import { useEffect } from 'react';

/**
 * Sets `document.title` while the calling component is mounted.
 *
 * The shells set the title for the routes they wrap: AppShell from the matched nav item, FlowShell
 * from its own suffix, and PublicShell from the zone's app title — that last one through this hook,
 * added because until then nothing set it and every public page inherited index.html's
 * "AKIS — Cabinet".
 *
 * The MPass screens are outside all three shells — they are deliberately chrome-less — so without
 * this they would keep whatever title the previously visited route left behind, which for a failed
 * sign-in is whichever page the visitor was on when they clicked "sign in".
 *
 * The title is restored on unmount so a client-side navigation away from one of these pages does
 * not strand its title on the next route.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
